/**
 * Een rij taken die STUK VOOR STUK draaien.
 *
 * WAAROM DIT ER MOEST KOMEN. De speler heeft twee wegen naar geluid. De Web
 * Audio-weg plant elk stuk op de klok van de AudioContext, precies waar het
 * vorige ophoudt - die sluiten vanzelf aan. De terugvalweg, een <audio>-element,
 * had niets: elk stuk begon op het moment dat het binnenkwam.
 *
 * Zolang een vertaling uit een stuk bestond viel dat niet op. Sinds spraak per
 * zin binnenkomt wel: vier stukken werden vier elementen, en die spelen
 * allemaal tegelijk. Giovanni hoorde dat op 4 september 2026 meteen.
 *
 * Een taak die struikelt houdt de rij niet tegen. Een zin die niet klinkt is
 * vervelend; een rij die vastloopt maakt de rest van het gesprek stil.
 */
export interface Wachtrij {
  /** Zet een taak achteraan. Wacht tot alles ervoor klaar is. */
  voegToe: (taak: () => Promise<void>) => Promise<void>;
  /** Vergeet wat er nog in de rij staat. Lopend werk stopt hier niet van. */
  leeg: () => void;
  /**
   * Hoeveel taken er nog lopen of wachten.
   *
   * Nodig om te weten wanneer het geluid ECHT afgelopen is. Zonder dit viel de
   * melding "speelt af" tussen twee stukken even weg, en daarmee kwamen de
   * andere afspeelknoppen een moment vrij - precies wat we niet willen.
   */
  open: () => number;
}

export function maakWachtrij(): Wachtrij {
  let staart: Promise<void> = Promise.resolve();
  // Elke ronde krijgt een eigen merk. Na leegmaken laten taken van de vorige
  // ronde zichzelf vallen in plaats van alsnog te beginnen.
  let ronde = 0;
  let open = 0;

  return {
    voegToe: (taak) => {
      const mijnRonde = ronde;
      const vorige = staart;
      open++;
      staart = (async () => {
        try {
          await vorige;
          if (mijnRonde !== ronde) return;
          await taak();
        } catch {
          // Zie de toelichting boven: doorgaan is beter dan blokkeren.
        } finally {
          open--;
        }
      })();
      return staart;
    },
    leeg: () => {
      ronde++;
      staart = Promise.resolve();
    },
    open: () => open,
  };
}
